type DebugPayload = Record<string, unknown>;

const debugEnv = (import.meta as ImportMeta & {
  env?: Record<string, string | boolean | undefined>;
}).env ?? {};

export const DOC_VERSION_DEBUG =
  debugEnv.DEV === true
  || debugEnv.VITE_DOC_VERSION_DEBUG === '1'
  || debugEnv.DOC_VERSION_DEBUG === '1';

export function docVersionDebugLog(event: string, payload: DebugPayload = {}): void {
  if (!DOC_VERSION_DEBUG) return;
  console.info(`[VersionClick] ${event}`, payload);
}

